/* Calendar dates as the API sends them: "YYYY-MM-DD". */

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

/** Today on this device's calendar, e.g. "2026-09-15". */
export function todayIso(now: Date = new Date()): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** "2026-09-14" plus 7 days is "2026-09-21"; empty for an invalid date. */
export function addDays(iso: string, days: number): string {
  const date = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(date.getTime()) || !Number.isFinite(days)) return "";
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

/** The Indian financial year of a date, as in invoice numbers: "2026-03-31" is "25-26". */
export function fyCode(iso: string): string {
  const year = Number(iso.slice(0, 4));
  const month = Number(iso.slice(5, 7));
  const start = month >= 4 ? year : year - 1;
  return `${pad(start % 100)}-${pad((start + 1) % 100)}`;
}
